import { AiAssistantConfigProps } from "types/appFunctionality";

type CheckAIChatAvailabilityProps = {
    config: AiAssistantConfigProps;
}

export function checkAIChatAvailability({ config }: CheckAIChatAvailabilityProps): boolean {
    return config.enabled === "enabled";
}
